exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Divider_divider__3utla {\n  position: relative;\n  z-index: 97; }\n  .Divider_divider__3utla:after {\n    position: absolute;\n    background-color: #505050;\n    content: ''; }\n  .Divider_divider__3utla.Divider_horizontal__2bcot {\n    width: 7px;\n    margin: 0 -3px;\n    cursor: ew-resize; }\n    .Divider_divider__3utla.Divider_horizontal__2bcot:after {\n      top: 0;\n      bottom: 0;\n      left: 3px;\n      width: 1px; }\n  .Divider_divider__3utla.Divider_vertical__Qkg9i {\n    height: 7px;\n    margin: -3px 0;\n    cursor: ns-resize; }\n    .Divider_divider__3utla.Divider_vertical__Qkg9i:after {\n      left: 0;\n      right: 0;\n      top: 3px;\n      height: 1px; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"divider": "Divider_divider__3utla",
	"horizontal": "Divider_horizontal__2bcot",
	"vertical": "Divider_vertical__Qkg9i"
};